import { Component } from '@angular/core';
import { MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';

@Component({
    selector: 'app-pdf-upload-dialog',
    templateUrl: './pdf-upload-dialog.component.html',
    styleUrls: ['./pdf-upload-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatDialogActions]
})
export class PdfUploadDialog {
  constructor(
      public dialogRef: MatDialogRef<PdfUploadDialog>
  ) {}

  close(): void {
    this.dialogRef.close();
  }
  
}
